import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { map } from 'lodash-es';
import styled from 'styled-components';

import { getTemplateList } from '@/store/templateList/actions';
import { getApiPath } from '@/services/Secuirty';

import { DefaultActivationTemplateScreenshot } from '@/services/icons/DefaultActivationTemplate';
import { TemplatesList } from '../FormStep3Interfaces';

export const ImageWrapper = styled.div`
    height: 64px;
    width: 64px;
    margin-right: 16px;

    img, svg {
        width: 100%;
        height: 100%;
    }
`;

export const useTemplatesList = (templateSearch):TemplatesList[] => {
    const { templatesList } = useSelector(getTemplateList);
    const { t } = useTranslation();

    if (!templatesList.length) {
        return([{
            label: t('noresults'),
            image: null,
            value: "noresults",
        }]);
    }

    const templateList = map(templatesList, template => ({
        image: <ImageWrapper><img src={`${getApiPath()}/userfile${encodeURI(template.Thumbnail)}`} /></ImageWrapper>,
        label: template.Name,
        value: template.Name
    }));

    if (!templateSearch) {
        templateList.unshift({
            label: t('default'),
            image: <ImageWrapper><DefaultActivationTemplateScreenshot /></ImageWrapper>,
            value: "default",
        });
    }

    return templateList;
}